import { Component, inject, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { CommercialOffice } from '@adgate/common/types/commercial-office.type';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CustomValidators } from '@adgate/common/validators/custom-validators.validator';

@Component({
  selector: 'app-office-edit-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule
  ],
  templateUrl: './office-edit-dialog-component.html',
  styleUrl: './office-edit-dialog-component.scss',
})
export class OfficeEditDialogComponent implements OnInit
{
  private dialogRef: MatDialogRef<OfficeEditDialogComponent> = inject(MatDialogRef);
  private fb: FormBuilder = inject(FormBuilder);

  public data: CommercialOffice = inject(MAT_DIALOG_DATA, { optional: false });

  officeForm: FormGroup;

  constructor()
  {
    this.officeForm = this.fb.group({
      commercialOffice: ['', [Validators.required, CustomValidators.invalidCharactersValidator()]],
      externalId: ['']
    });
  }

  ngOnInit(): void
  {
    if( this.data?.id != -1 ) {
      this.officeForm.get('commercialOffice')?.setValue(this.data?.description);
      this.officeForm.get('externalId')?.setValue(this.data?.externalId);
    }
  }

  onCancel(): void
  {
    this.dialogRef.close(null);
  }

  onSubmit(): void
  {
    if( this.officeForm.valid ) {
      this.data.description = this.officeForm.get('commercialOffice')?.value;
      this.data.externalId = this.officeForm.get('externalId')?.value;

      this.dialogRef.close( this.data );
    }
  }
}
